// extracted by mini-css-extract-plugin
export var byline = "bj_dB";
export var bylineItem = "bj_dC";